import Vue from 'vue'
import Vuetify from 'vuetify'
import colors from 'vuetify/lib/util/colors'
import ja from 'vuetify/src/locale/ja'
import axios from 'axios'
import store from '@/store-entry'
import 'vuetify/dist/vuetify.css'
import '@/sass/global.sass'
import SignUpIndex from '@/pages/sign_up/Index.vue'
import MyPageIndex from '@/pages/mypage/Index.vue'
import SettingsIndex from '@/pages/settings/Index.vue'
import FavoritesIndex from '@/pages/favorites/Index.vue'
import SignInIndex from '@/pages/sign_in/Index.vue'
import PasswordsIndex from '@/pages/passwords/Index.vue'
import PasswordsEdit from '@/pages/passwords/Edit.vue'
import EventAttend from "@/pages/events/Attend.vue"
import EventActivation from "@/pages/events/Activation.vue"
import EventShow from "@/pages/events/Show.vue"
import UserActivation from "@/pages/users/Activation.vue"
import UserEmailConfirmation from "@/pages/users/EmailConfirmation.vue"
import EventShowForUser from "@/pages/events/ShowForUser.vue"
import EventIndex from "@/pages/events/Index.vue"

Vue.use(Vuetify)

const vuetify = new Vuetify({
  lang: {
    locales: { ja },
    current: 'ja'
  },
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: colors.blue.darken4,
        accent: colors.orange.darken4,
        error: colors.red.base,
        secondary: colors.blueGrey.base
      }
    }
  }
})

setTimeout(() => {
  const settingsElement = document.querySelector('meta[name=settings]') as any
  const settings = JSON.parse(settingsElement.content)
  store.dispatch('setSettings', settings)
  if (document.getElementById('sign_up')) {
    new Vue({
      el: '#sign_up',
      render: h => h(SignUpIndex),
      vuetify,
      store
    })
  } else if (document.getElementById('sign_in')) {
    new Vue({
      el: '#sign_in',
      render: h => h(SignInIndex),
      vuetify,
      store
    })
  } else if (document.getElementById('mypage')) {
    new Vue({
      el: '#mypage',
      render: h => h(MyPageIndex),
      vuetify,
      store
    })
  } else if (document.getElementById('favorites')) {
    new Vue({
      el: '#favorites',
      render: h => h(FavoritesIndex),
      vuetify,
      store
    })
  } else if (document.getElementById('settings')) {
    new Vue({
      el: '#settings',
      render: h => h(SettingsIndex),
      vuetify,
      store
    })
  } else if (document.getElementById('passwords')) {
    new Vue({
      el: '#passwords',
      render: h => h(PasswordsIndex),
      vuetify,
      store
    })
  } else if (document.getElementById('passwords_edit')) {
    new Vue({
      el: '#passwords_edit',
      render: h => h(PasswordsEdit),
      vuetify,
      store
    })
  } else if (document.getElementById('event_attend')) {
    new Vue({
      el: '#event_attend',
      render: h => h(EventAttend),
      vuetify,
      store
    })
  } else if (document.getElementById('event_activation')) {
    new Vue({
      el: '#event_activation',
      render: h => h(EventActivation),
      vuetify,
      store
    })
  } else if (document.getElementById('events')) {
    new Vue({
      el: '#events',
      render: h => h(EventIndex),
      vuetify,
      store
    })
  } else if (document.getElementById('event_show')) {
    new Vue({
      el: '#event_show',
      render: h => h(EventShow),
      vuetify,
      store
    })
  } else if (document.getElementById('event_show_for_user')) {
    new Vue({
      el: '#event_show_for_user',
      render: h => h(EventShowForUser),
      vuetify,
      store
    })
  } else if (document.getElementById('user_activation')) {
    new Vue({
      el: '#user_activation',
      render: h => h(UserActivation),
      vuetify,
      store
    })
  } else if (document.getElementById('user_email_confirmation')) {
    new Vue({
      el: '#user_email_confirmation',
      render: h => h(UserEmailConfirmation),
      vuetify,
      store
    })
  }
  // setTimeout(() => {
  //   document.getElementById('sign_up').classList.add('displayed')
  // })
}, 1000)

axios.interceptors.request.use(request => {
  const tokenElement = document.querySelector('meta[name=csrf-token]') as any
  request.headers.contentType = 'application/json; charset=utf8'
  request.headers.dataType = 'json'
  request.headers['X-CSRF-TOKEN'] = tokenElement ? tokenElement.content : null
  return request
})
